// Side-effect module, imported FIRST in main.tsx: it must rewrite a Supabase
// auth callback URL before the router, supabase-js or checkAuth read it.
import { rewriteAuthCallbackUrl } from "./authCallbackUrl";

rewriteAuthCallbackUrl();
// An auth link opened in a tab where the app already runs (same document).
window.addEventListener("hashchange", () => rewriteAuthCallbackUrl());
